import { z } from 'zod';
import { GitProviderType, RemoteTypes } from '../../types/remotes';
export var ProjectTriggerType;
(function (ProjectTriggerType) {
    ProjectTriggerType["PROJECT_SOURCE_SWITCH"] = "PROJECT_SOURCE_SWITCH";
    ProjectTriggerType["PROJECT_BUILD_MANUAL_TRIGGER"] = "PROJECT_BUILD_MANUAL_TRIGGER";
    ProjectTriggerType["PROJECT_SOURCE_PUSH"] = "PROJECT_SOURCE_PUSH";
    ProjectTriggerType["PROJECT_SOURCE_PR_CREATED"] = "PROJECT_SOURCE_PR_CREATED";
    ProjectTriggerType["PROJECT_SOURCE_PR_CREATED_BY_REMOTE"] = "PROJECT_SOURCE_PR_CREATED_BY_REMOTE";
    ProjectTriggerType["REMOTE_CONTENT_PUSH"] = "REMOTE_CONTENT_PUSH";
    ProjectTriggerType["SCOUT_PUSH"] = "SCOUT_PUSH";
})(ProjectTriggerType || (ProjectTriggerType = {}));
const internalRepoDetailsSchema = z.object({
    isInternal: z.literal(true),
    branchName: z.string().min(1),
});
const externalRepoDetailsSchema = z.object({
    isInternal: z.literal(false),
    branchName: z.string().min(1),
    repoName: z.string().min(1),
    repoUrl: z.string().min(1).optional(),
    contentPath: z.string().min(1),
    providerType: z.nativeEnum(GitProviderType),
});
const commitMessageSchema = z.object({
    message: z.string().min(1),
});
const commitShaSchema = z.object({
    sha: z.string().min(1),
    prId: z.string().optional(),
});
const optionalCommitShaSchema = z.object({
    sha: z.string().min(1).optional(),
});
const optionalCommitUrlSchema = z.object({
    url: z.string().min(1).optional(),
});
const commitSchema = z
    .object({
    url: z.string().min(1),
})
    .and(commitShaSchema)
    .and(commitMessageSchema);
export const projectSourceSwitchTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.PROJECT_SOURCE_SWITCH),
    from: z.union([internalRepoDetailsSchema, externalRepoDetailsSchema]),
    to: z.union([internalRepoDetailsSchema, externalRepoDetailsSchema]),
});
export const projectSourcePushTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.PROJECT_SOURCE_PUSH),
    source: z.union([internalRepoDetailsSchema, externalRepoDetailsSchema]),
    commit: commitSchema,
});
export const projectSourcePrCreatedTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.PROJECT_SOURCE_PR_CREATED),
    source: z.union([internalRepoDetailsSchema, externalRepoDetailsSchema]),
    pullRequest: z.object({
        url: z.string().optional(),
        prNumber: z.number().optional(),
        commit: commitMessageSchema.and(commitShaSchema),
    }),
});
export const projectBuildManualTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.PROJECT_BUILD_MANUAL_TRIGGER),
});
export const gitRemotePushTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.REMOTE_CONTENT_PUSH),
    remoteType: z.literal(RemoteTypes.GIT),
    remoteId: z.string().min(1),
    commit: commitSchema,
    branchName: z.string().min(1),
    repoName: z.string().min(1),
    repoUrl: z.string().min(1).optional(),
    providerType: z.nativeEnum(GitProviderType),
    mountPath: z.string().min(1),
});
export const cicdRemotePushTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.REMOTE_CONTENT_PUSH),
    remoteType: z.literal(RemoteTypes.CICD),
    remoteId: z.string().min(1),
    commit: commitMessageSchema.and(optionalCommitShaSchema).and(optionalCommitUrlSchema),
    pushId: z.string().min(1),
    mountPath: z.string().min(1),
});
export const urlRemotePushTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.REMOTE_CONTENT_PUSH),
    remoteType: z.literal(RemoteTypes.URL),
    remoteId: z.string().min(1),
    url: z.string().min(1),
    mountPath: z.string().min(1),
});
export const remotePushTriggerSchema = z.union([
    gitRemotePushTriggerSchema,
    cicdRemotePushTriggerSchema,
    urlRemotePushTriggerSchema,
]);
export const scoutPushTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.SCOUT_PUSH),
    remoteId: z.string().min(1),
    commit: commitMessageSchema.and(commitShaSchema).and(optionalCommitUrlSchema),
    mountPath: z.string().min(1),
    jobId: z.string().min(1),
    pushId: z.string().min(1),
    jobContext: z.string().min(1).optional(),
});
export const projectSourcePrCreatedByRemoteTriggerSchema = z.object({
    type: z.literal(ProjectTriggerType.PROJECT_SOURCE_PR_CREATED_BY_REMOTE),
    source: z.union([internalRepoDetailsSchema, externalRepoDetailsSchema]),
    pullRequest: z.object({
        url: z.string().optional(),
        prNumber: z.number().optional(),
        commit: commitMessageSchema.and(commitShaSchema),
    }),
    initiatedBy: z.union([remotePushTriggerSchema, scoutPushTriggerSchema]),
});
export const projectBuildTriggerSchema = z.union([
    projectSourceSwitchTriggerSchema,
    projectSourcePushTriggerSchema,
    projectSourcePrCreatedTriggerSchema,
    projectSourcePrCreatedByRemoteTriggerSchema,
    projectBuildManualTriggerSchema,
    remotePushTriggerSchema,
    scoutPushTriggerSchema,
]);
//# sourceMappingURL=build-trigger.js.map